import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { CustomRequestService } from '../../../services/custom-request/custom-request.service';
import { LzUserServiceV2 } from "../../lz-user/services/lz-user.serivce.v2";
import { LzProductConfig } from '../../../services/product-config/poduct-config';

@Injectable()

export class LzUserMessagesService {

  private userMessagesSource = new BehaviorSubject < any > ([]);
  public currentUserMessages: Observable < any > = this.userMessagesSource.asObservable();
  private localUserMessages: any = [];
  private page: number = 0;
  private count: number = 0;
  private isGetAll = false;

  private userMessagesCountSource = new BehaviorSubject < any > (0);
  public currentUserMessagesCount: Observable < any > = this.userMessagesSource.asObservable();
  private localUserMessagesCount: any = 0;

  private config: any = [];

  constructor(private customRequestService: CustomRequestService,
    private user: LzUserServiceV2,
    private lzProductConfig: LzProductConfig) {
    this.config = this.lzProductConfig.getProductSettings();
    this.updateUserMessages('first time');
    this.updateUserMessagesCount();
  }

  updateUserMessages = (type ? : string) => {
    let lastPage = -1;
    switch (type) {
      case 'first time':
        this.isGetAll = false;
        this.page = 0;
        this.count = 5;
        this.localUserMessages = [];
        break;
      case 'next':
        this.page += 1;
        this.count = 5;
        this.isGetAll = false;
        break;
      case 'update':
        this.isGetAll = false;
        this.count = (this.page + 1) * 5;
        lastPage = this.page;
        this.page = 0;
        this.localUserMessages = [];
        break;
      default:
        this.isGetAll = false;
        this.count = (this.page + 1) * 5;
        break;
    }
    if (!this.isGetAll) {
      this.user.getUserInfo((data) => {
        if (data.anonymous == false) {
          this.customRequestService.getRequest(this.lzProductConfig.getApiLink() + '/lz-platforma/notifications/v1.0/user/messages', {
              p: this.page,
              size: this.count
            })
            .subscribe(
              (msg) => {
                let data = JSON.parse(JSON.stringify(msg)).data;
                this.localUserMessages = this.localUserMessages.concat(data);
                if (data.length < 5) {
                  this.isGetAll = true;
                }
                this.userMessagesSource.next({
                  'messages': this.localUserMessages,
                  'count': data.length,
                  'isGetAll': this.isGetAll
                });
                if (lastPage != -1) {
                  this.page = lastPage;
                  lastPage = -1;
                }
              }
            );
        }
      });
    }
  }

  updateUserMessagesCount = () => {
    this.user.getUserInfo((data) => {
      if (data.anonymous == false) {
        this.customRequestService.getRequest(this.lzProductConfig.getApiLink() + '/lz-platforma/notifications/v1.0/user/count')
          .subscribe(msg => {
            let msgTmp = JSON.parse(JSON.stringify(msg)).unread;
            let count = 0;
            if (msgTmp > 99) {
              count = 99;
            } else {
              if (msgTmp != 0 && msgTmp) {
                count = msgTmp;
              }
            }
            this.userMessagesCountSource.next(count);
            this.localUserMessagesCount = count;
          });
      }
    });
  };

  sendCommand = data => {
    return this.customRequestService.postRequestWithFormData(
      'lzservice/userSettings/sendCommand',
      data,
      false, {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    ).subscribe(() => {});
  };

  markAsLooked = (id ? , options ? ) => {
    let unid = 0;
    if (id) {
      unid = id;
    } else {
      if (options.id) {
        unid = options.id;
      }
      if (options.unid) {
        unid = options.unid;
      }
    }
    this.customRequestService.postRequest('pushnotification/notification/set/viewed/' + unid)
      .subscribe(function () {
        this.updateUserMessagesCount();
        this.updateUserMessages('update');

        let parameters = JSON.stringify({
          id: unid,
          type: options.type,
          contentType: options.contentType
        });

        this.sendCommand({
          command: 'close',
          parameters: parameters
        });
      }.bind(this));
  };

  markAsVisited = (id ? , options ? ) => {
    let unid = 0;
    if (id) {
      unid = id;
    } else {
      if (options.id) {
        unid = options.id;
      }
      if (options.unid) {
        unid = options.unid;
      }
    }
    this.customRequestService.postRequest('pushnotification/notification/set/viewed/' + unid)
      .subscribe(function () {
        this.customRequestService.postRequest('pushnotification/notification/set/visited/' + unid)
          .subscribe(function () {
            this.updateUserMessagesCount();
            this.updateUserMessages('update');

            let parameters = JSON.stringify({
              id: unid,
              type: options.type,
              contentType: options.contentType
            });

            this.sendCommand({
              command: 'close',
              parameters: parameters
            });
          }.bind(this));
      }.bind(this));
  }

  markAllAsLooked = () => {
    this.customRequestService.postRequest('pushnotification/notification/set/viewed/all')
      .subscribe(function () {
        this.updateUserMessagesCount();
        this.updateUserMessages('update');

        let parameters = JSON.stringify({
          id: 0,
          type: "SYSTEM",
          contentType: "TEXT"
        });

        this.sendCommand({
          command: 'close',
          parameters: parameters
        });
      }.bind(this));
  }

  getUserMessagesCount = () => {
    return this.localUserMessagesCount;
  }

  getMessegesList = () => {
    return this.localUserMessages;
  }

}
